function copyToClipboard(event) {
  console.log("Copy button clicked"); // 调试日志
  if (event) {
    console.log("stopPropagation"); // 调试日志
    event.stopPropagation(); // <--- 核心：阻止冒泡
    event.preventDefault();
  }

  // 1. 获取要复制的文本
  const textToCopy = document.getElementById("coupon-text").innerText.trim();
  const btn = document.querySelector(".copy-btn");
  const iconCopy = btn.querySelector(".icon-copy");
  const iconCheck = btn.querySelector(".icon-check");

  // 2. 执行复制操作
  if (navigator.clipboard && window.isSecureContext) {
    // 现代浏览器方法 (HTTPS 环境下)
    navigator.clipboard.writeText(textToCopy).then(onSuccess, onError);
  } else {
    // 降级方案 (HTTP 或旧浏览器)
    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      onSuccess();
    } catch (err) {
      onError();
    }
    document.body.removeChild(textArea);
  }

  // 3. 成功后的 UI 反馈
  function onSuccess() {
    console.log("文本已复制: "); // 调试日志
    // 切换图标
    iconCopy.style.display = "none";
    iconCheck.style.display = "block";
    btn.classList.add("copy-success");

    // 2 秒后恢复原状
    setTimeout(() => {
      iconCopy.style.display = "block";
      iconCheck.style.display = "none";
      btn.classList.remove("copy-success");
    }, 2000);
  }

  // 4. 错误处理
  function onError() {
    console.error("无法复制文本");
    alert("复制失败，请手动复制");
  }
}
